export default import.meta.ROLLDOWN_FILE_URL_MFdVU$3Z9gwG34EV6W5zBQ